import styled from 'styled-components';

export const AvatarListComp = styled.div`
  display: flex;
  .AvatarList__Avatar {
    width: 20px;
    height: 20px;
    position: relative;
    img {
      width: 20px !important;
      height: 20px !important;
    }
  }
  .AvatarList_Emit {
    width: 20px;
    height: 20px;
    position: relative;
    left: -5px;
  }
`;
